/**
 * modal.js — mở/đóng modal thành công sau khi gửi form.
 *
 * CSS đã mở modal bằng :target nên modal chạy được cả khi JS lỗi; file này chỉ
 * nâng cấp trải nghiệm: khoá cuộn nền, đưa focus vào panel, giữ focus trong panel,
 * Esc để đóng và trả focus về chỗ cũ.
 *
 * Nút đóng là thẻ <a> chứ không phải <button> nên danh sách focus phải tính cả <a>.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
    var openModal = null;
    var lastFocus = null;

    function panelOf(modal) {
        return modal.querySelector('.modal__panel');
    }

    function open(modal) {
        if (!modal || openModal === modal) return;

        openModal = modal;
        lastFocus = document.activeElement;

        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';

        var panel = panelOf(modal);
        if (panel) {
            if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
            panel.focus();
        }
    }

    function close() {
        if (!openModal) return;

        openModal.classList.remove('is-open');
        openModal = null;
        document.body.style.overflow = '';

        // Xoá hash để F5 không mở lại modal, nhưng giữ nguyên lịch sử.
        if (window.history && window.history.replaceState) {
            window.history.replaceState(null, '', window.location.pathname + window.location.search);
        }

        if (lastFocus && lastFocus.focus) lastFocus.focus();
        lastFocus = null;
    }

    function fromHash() {
        var hash = window.location.hash;
        if (!hash || hash.length < 2) return;

        var target = document.getElementById(hash.slice(1));
        if (target && target.classList.contains('modal')) open(target);
    }

    document.addEventListener('click', function (event) {
        var closer = event.target.closest ? event.target.closest('.modal__close, .modal__overlay') : null;

        if (closer && openModal && openModal.contains(closer)) {
            event.preventDefault();
            close();
            return;
        }

        // Nút "Close" trong .modal__actions trỏ href="#"
        var action = event.target.closest ? event.target.closest('.modal__actions a[href="#"]') : null;
        if (action && openModal && openModal.contains(action)) {
            event.preventDefault();
            close();
        }
    });

    document.addEventListener('keydown', function (event) {
        if (!openModal) return;

        if (event.key === 'Escape' || event.key === 'Esc') {
            close();
            return;
        }

        if (event.key !== 'Tab') return;

        var panel = panelOf(openModal);
        if (!panel) return;

        var items = [].slice.call(panel.querySelectorAll(FOCUSABLE)).filter(function (el) {
            return el.offsetWidth > 0 || el.offsetHeight > 0;
        });

        if (!items.length) return;

        var first = items[0];
        var last = items[items.length - 1];

        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    });

    window.addEventListener('hashchange', fromHash);
    fromHash();
})();
